import { render, staticRenderFns } from "./ProfileLoader.vue?vue&type=template&id=ef60961e&scoped=true&"
import script from "./ProfileLoader.vue?vue&type=script&lang=js&"
export * from "./ProfileLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLoader.vue?vue&type=style&index=0&id=ef60961e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef60961e",
  null
  
)

export default component.exports